module.exports = __webpack_public_path__ + "img/EY__wavespace_lg.1a9fe94f.png";